/**
 * T105: Categories Settings Page
 * Page for managing categories
 */

import { Link } from '@tanstack/react-router'
import { ChevronLeft } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { CategoryList } from '@/components/settings/category-list'

export function CategoriesPage() {
  return (
    <div className="space-y-6">
      <div>
        <Button variant="ghost" size="sm" asChild className="mb-2">
          <Link to="/settings">
            <ChevronLeft className="mr-1 h-4 w-4" />
            Back to Settings
          </Link>
        </Button>
        <h1 className="text-3xl font-bold">Categories</h1>
        <p className="mt-2 text-muted-foreground">
          Manage categories to organize your prompts.
        </p>
      </div>

      <CategoryList />
    </div>
  )
}
